import { useRef, useState } from 'react'
import { convertToRupiah } from '../../../helper/Rupiah'

// Deposit isian finance (deposit_manual): siapa dan kapan mengisi, tampil di bawah nominal
const ManualDepositInfo = ({ data }) =>
  data.deposit_manual != null && (
    <div className="text-muted" style={{ fontSize: '11px' }}>
      {data.deposit_manual_by} · {data.deposit_manual_at}
    </div>
  )

const VendorTableItem = (props) => {
  const data = props.data
  const [editing, setEditing] = useState(false)
  const [saving, setSaving] = useState(false)
  const [value, setValue] = useState('')
  // Simpan hanya lewat onBlur (Enter = lepas fokus), supaya tidak terkirim dua kali
  const busyRef = useRef(false)
  const cancelRef = useRef(false)

  const startEdit = () => {
    cancelRef.current = false
    setValue(data.deposit_manual == null ? '' : String(data.deposit_manual))
    setEditing(true)
  }

  // Kosong = kembali "Belum diisi"; nilai tidak berubah = tidak disimpan
  const save = async () => {
    if (busyRef.current) {
      return
    }

    const nominal = value === '' ? null : Number(value)
    const current = data.deposit_manual == null ? null : Number(data.deposit_manual)

    if (cancelRef.current || nominal === current) {
      setEditing(false)
      return
    }

    busyRef.current = true
    setSaving(true)
    const saved = await props.onSaveDeposit(data.id, nominal)
    busyRef.current = false
    setSaving(false)

    if (saved) {
      setEditing(false)
    }
  }

  const keyDownHandler = (e) => {
    if (e.key === 'Escape') {
      cancelRef.current = true
    }

    if (e.key === 'Enter' || e.key === 'Escape') {
      e.target.blur()
    }
  }

  const depositCell = () => {
    if (!props.editableDeposit) {
      return (
        <>
          Rp. {convertToRupiah(data.deposit)}
          <ManualDepositInfo data={data} />
        </>
      )
    }

    if (editing) {
      return (
        <input
          type="text"
          inputMode="numeric"
          autoFocus
          disabled={saving}
          value={value ? convertToRupiah(value) : ''}
          onChange={(e) => setValue(e.target.value.replace(/\D/g, ''))}
          onBlur={save}
          onKeyDown={keyDownHandler}
          placeholder="Kosongkan = belum diisi"
          className="form-control form-control-sm text-end"
          style={{ minWidth: '140px' }}
        />
      )
    }

    return (
      <div role="button" onClick={startEdit} title="Klik untuk mengisi deposit">
        {data.deposit_manual == null ? (
          <span className="text-muted fst-italic">Belum diisi</span>
        ) : (
          <>Rp. {convertToRupiah(data.deposit_manual)}</>
        )}
        <i className="fa fa-pencil ms-2 text-muted" />
        <ManualDepositInfo data={data} />
      </div>
    )
  }

  return (
    <tr>
      <td>{props.no}</td>
      <td>{data.project_id}</td>
      <td>{data.id_survey || '-'}</td>
      <td>{data.project_name}</td>
      <td>{data.client_name}</td>
      {props.dateColumns.map((c) => (
        <td key={c.key}>{data[c.key] || '-'}</td>
      ))}
      {props.showValue && (
        <td>{data.nilai_penawaran == null ? '-' : `Rp. ${convertToRupiah(data.nilai_penawaran)}`}</td>
      )}
      <td>{depositCell()}</td>
      <td>{data.payment_method ? data.payment_method : '-'}</td>
      <td>{data.payment_channel ? data.payment_channel : '-'}</td>
      <td>{data.fee_transfer}</td>
    </tr>
  )
}

export default VendorTableItem
